define('views/pages/CheckoutPendingPageView',['underscore','PageView', 'ApiRequest', 'app'],
    function (_,PageView, ApiRequest, app) {

    //
    // Checkout Pending
    //
    var CHECKOUT_PENDING_REFRESH_DELAY_DEFAULT = 4;
    var CHECKOUT_PENDING_REFRESH_DELAY_WARN = 30;

    return PageView.extend({
        pageName: 'CheckoutPending',
        hideMobileCart: true,
        hideFooter: true,
        initialize: function (options) {
            var refresh_delay = parseInt(app.c('_CHECKOUT_PENDING_REFRESH_DELAY_', CHECKOUT_PENDING_REFRESH_DELAY_DEFAULT)) * 1000;
            var refresh_delay_warn = parseInt(app.c('_CHECKOUT_PENDING_REFRESH_DELAY_WARN_', CHECKOUT_PENDING_REFRESH_DELAY_WARN)) * 1000;
            var refresh_count = 0, refresh_timeout= 0;
            var d0 = new Date().getTime();
            var messageEl = this.$('.pending-message');
            var searchParams = new URLSearchParams(window.location.search);
            var paymentId = searchParams.get("paymentId");
            var hostedCheckoutId = searchParams.get("hostedCheckoutId");
            var action = "none";
            var payment_action_id = "";
            var Refresh = function(delay){
                clearTimeout(refresh_timeout);
                return refresh_timeout = setTimeout(function () {
                    ApiRequest("OrderPending",null, {payment_action_id: payment_action_id, action: action}).done(function (data) {
                        var state = data.state;
                        switch(state){
                            case "error":
                                window.location.href="/checkout/error";
                                return
                                break;
                            case "confirmation":
                                window.location.href="/checkout/confirmation";
                                return
                                break;
                            default:
                            case "pending":
                                refresh_count++;
                                Refresh(refresh_count*refresh_delay);
                                break;
                        }
                        var d = new Date().getTime();
                        var refresh_total_time = d - d0;
                        if(refresh_total_time < refresh_delay_warn) {
                            messageEl.text(app.t("Cela ne devrait prendre plus que quelques instants…","Checkout"));
                        }else{
                            messageEl.text(app.t("Le traitement est plus long que prévu, nous attendons la confirmation de votre paiement…","Checkout"));
                        }
                    }).fail(function (error) {
                        refresh_count++;
                        Refresh(refresh_count*refresh_delay);
                    });
                },delay);
            }
            // deux types d'Id peuvent être utilisés pour le refresh
            // paymentId et hostedCheckoutId
            if(!!paymentId){
                action = "paymentid";
                payment_action_id = paymentId;
            }else if(!!hostedCheckoutId){
                action = "hostedcheckoutid";
                payment_action_id = hostedCheckoutId;
            }else{
                messageEl.text(app.t("Une erreur inconnue semble être apparue.","Error"));
            }
            if(!!payment_action_id){
                Refresh(refresh_delay);
            }
        },

    });

});

